import React from 'react';
import { FormattedMessage } from 'react-intl';

import Paper from '@/components/ui-bridge/core/Paper';

const styles = {
  paper: {
    textAlign: 'center',
    backgroundColor: '#D7D7D7',
  },
};

function ListRefresh(props) {
  return (
    <Paper style={styles.paper} elevation={0}>
      <FormattedMessage id="BUTTON.NEW_ITEMS_NOTIFICATION" />
    </Paper>
  );
}

export default ListRefresh;
